<template>
    <div class="b-pagination">
        <ul class="b-pagination__ctrls">
            <li v-if="totalPages > 2">
                <a
                    href="javascript:void(0)"
                    type="button"
                    :class="[
                        'b-pagination__link b-pagination__link--first icon-arrow-first',
                        { disabled: currentPage == 1 },
                    ]"
                    :title="appData?.dictionary.firstPage"
                    @click="goToFirstPage" />
            </li>
            <li v-if="totalPages > 1">
                <a
                    href="javascript:void(0)"
                    type="button"
                    :class="[
                        'b-pagination__link b-pagination__link--prev icon-arrow-prev',
                        { disabled: currentPage == 1 },
                    ]"
                    :title="appData?.dictionary.previousPage"
                    @click="goToPrevPage" />
            </li>
            <li v-if="totalPages > 1">
                <a
                    href="javascript:void(0)"
                    type="button"
                    :class="[
                        'b-pagination__link b-pagination__link--next icon-arrow-next',
                        { disabled: currentPage == totalPages },
                    ]"
                    :title="appData?.dictionary.nextPage"
                    @click="goToNextPage" />
            </li>
            <li v-if="totalPages > 2">
                <a
                    href="javascript:void(0)"
                    type="button"
                    :class="[
                        'b-pagination__link b-pagination__link--last icon-arrow-last',
                        { disabled: currentPage == totalPages },
                    ]"
                    :title="appData?.dictionary.lastPage"
                    @click="goToLastPage" />
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    props: {
        totalPages: {
            type: Number,
            default: 0,
        },
    },

    emits: ['page-updated'],

    data() {
        return {
            currentPage: 1,
        }
    },

    methods: {
        goToFirstPage() {
            if (this.currentPage > 1) {
                this.setPage(1)
            }
        },
        goToPrevPage() {
            if (this.currentPage > 1) {
                this.setPage(this.currentPage - 1)
            }
        },
        goToNextPage() {
            if (this.currentPage < this.totalPages) {
                this.setPage(this.currentPage + 1)
            }
        },
        goToLastPage() {
            if (this.currentPage < this.totalPages) {
                this.setPage(this.totalPages)
            }
        },
        setPage(page) {
            this.currentPage = page
            this.$emit('page-updated', this.currentPage)
        },
    },
}
</script>
